<template>
  <div>
    <div class="modal" v-if="isModalOpen">
      <div class="modal-content" ref="modalRef">
        <button class="close-button" @click="closeModal"></button>
        <div class="holiday-info">
          <h1 class="holiday-info__title">
            ВАЖНО! <br />
            Пополните счет до 29 апреля
          </h1>
          <div class="holiday-info__text">
            С 30 апреля по 4 мая и с 7 по 11 мая банки уходят на каникулы и не
            обрабатывают платежи. Успейте пополнить рекламный кабинет до 29
            апреля, чтобы ваш бюджет был готов к праздникам.
          </div>
          <div class="holiday-info__button">
            <button @click="handleOkayClick">Хорошо</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HolidayModal',
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
      initialBodyOverflow: null
    };
  },
  mounted() {
    if (this.isModalOpen) {
      document.addEventListener('mouseup', this.closeModalOnClickOutside);
      this.initialBodyOverflow = document.querySelector('body').style.overflow;
      this.setBodyOverflow('hidden');
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-holiday-modal');
      this.setBodyOverflow(this.initialBodyOverflow);
      document.removeEventListener('mouseup', this.closeModalOnClickOutside);
    },
    handleOkayClick() {
      this.$emit('follow-holiday');
      document.removeEventListener('mouseup', this.closeModalOnClickOutside);
    },
    closeModalOnClickOutside(event) {
      const modal = this.$refs.modalRef;
      if (!modal.contains(event.target)) {
        this.closeModal();
      }
    },
    setBodyOverflow(value) {
      let body = document.querySelector('body');
      body.style.overflow = value;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  overflow: auto;
  z-index: 3000;
}

.modal-content {
  max-height: 500px;
  height: 100%;
  max-width: 500px;
  width: 100%;
  padding: 4rem;
  padding-bottom: 7rem;
  border-radius: 1.6rem;
  margin: 10vh auto auto;
  position: relative;
  background-color: #ebf3fa;
}

.close-button {
  background: none;
  background-image: url('../../assets/icons/icon-close-black.svg');
  position: absolute;
  top: 2.4rem;
  right: 2.4rem;
  border: none;
  cursor: pointer;
  width: 3.2rem;
  height: 3.2rem;
}

.holiday-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__title {
    color: $basicBlack;
    text-align: center;
    font-family: 'Roboto';
    font-size: 3rem;
    font-style: normal;
    font-weight: 500;
    line-height: 4rem;
  }

  &__text {
    height: 100%;
    display: flex;
    align-items: center;
    color: $gray;
    font-family: 'Roboto';
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2.8rem;
    width: 100%;

    p {
      margin: 0;
    }
  }

  &__button {
    display: flex;

    button {
      padding: 1.6rem 8rem;
      background: #f96714;
      border: none;
      border-radius: 0.4rem;
      color: #fff;
      text-align: center;
      font-family: 'Roboto';
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.4rem;
      margin: auto;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #e05a0d;
      }
    }
  }
}

@include below(500px) {
  .modal-content {
    height: auto;
    padding: 2rem;
  }

  .holiday-info {
    gap: 2rem;

    &__text {
      margin: 0;
    }

    &__button {
      margin-top: 2rem;
    }
  }
}
</style>
